<!-- eslint-disable -->
<template>

    <div class="container-box">
        <button @click="toggleContent" class="toggle-button">
            {{ isSearchVisible ? '▲' : '▼' }}
        </button>
        <input type="text" v-model="searchQuery" placeholder="Search..." />
        <transition name="slide">
            <div v-if="isSearchVisible" class="content-container">
                <div class="searchBox">
                    <div class="search-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Reference</th>
                                    <th>Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in stateData.foundstops.value" :key="item.id">
                                    <td>{{ item.reference }}</td>
                                    <td>{{ item.fullname }}</td>
                                    <td><button @click="stateData.AddStop(item.reference)">Add</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</template>


<script setup>
/* eslint-disable */
import { ref, watch, inject } from 'vue';

const isSearchVisible = ref(true);
const searchQuery = ref('');

const stateData = inject('stateData');

const toggleContent = () => {
    isSearchVisible.value = !isSearchVisible.value;
};

let querytimeout;
watch(searchQuery, () => {
    clearTimeout(querytimeout);

    querytimeout = setTimeout(async () => {
        console.log(`StopSearch: watch(searchQuery) triggered with [${searchQuery.value}]`);
        stateData.findStops(searchQuery.value);
    }, 300); // Increased debounce to 300ms
});

console.log('StopSearch: Initial findStops("") call');
stateData.findStops("");
</script>

<style scoped>
.searchBox {
    display: flex;
    flex-direction: column;
}

.search-table {
    max-height: 150px;
    overflow-y: auto;
}

.content-container {
    overflow: hidden;
}
</style>